export default {
  Management: "https://combiqloud-prod-management.azurewebsites.net",
  FotaApp: "https://combiqloud-prod-fota.azurewebsites.net",
}
